import gql from 'graphql-tag'
import { productDetailFields } from './productGetQuery'

const productCreateQuery = gql`
  query productCreate(
    $productSku: String!
    $internalSku: String!
    $eshops: [String]!
    $expectedTurnover: String
    $expirationOffset: Number
    $inboundExpirationOffset: Number
    $outboundExpirationOffset: Number
    $localisation: [String]!
    $organisation: String!
    $name: String!
    $weight: Number!
    $height: Number!
    $width: Number!
    $length: Number!
    $codes: Array!
    $packagingType: String!
    $productGroup: String
    $services: [String]
    $features: [String]
    $workAroundSnIn: Boolean
    $workAroundLot: Boolean
    $active: Boolean
    $description: String
    $customsDescription: String
    $hsCode: String
    $countryOfOrigin: String
    $description: String
    $type: String
    $childrenProducts: Array
    $requiresAdditionalWork: Boolean
    $requiresQualitativeReceiving: Boolean
  ) {
    productCreate(
      input: {
        productSku: $productSku
        internalSku: $internalSku
        eshops: $eshops
        expectedTurnover: $expectedTurnover
        expirationOffset: $expirationOffset
        inboundExpirationOffset: $inboundExpirationOffset
        outboundExpirationOffset: $outboundExpirationOffset
        localisation: $localisation
        services: $services
        features: $features
        organisation: $organisation
        name: $name
        weight: $weight
        height: $height
        width: $width
        length: $length
        codes: $codes
        packagingType: $packagingType
        productGroup: $productGroup
        workAroundSnIn: $workAroundSnIn
        workAroundLot: $workAroundLot
        active: $active
        description: $description
        customsDescription: $customsDescription
        hsCode: $hsCode
        countryOfOrigin: $countryOfOrigin
        description: $description
        type: $type
        childrenProducts: $childrenProducts
        requiresAdditionalWork: $requiresAdditionalWork
        requiresQualitativeReceiving: $requiresQualitativeReceiving
      }
    ) @rest(method: "POST", path: "product") {
      ${productDetailFields}
    }
  }
`

export default productCreateQuery
